
export const PVP_BANNER_SRC = 'https://files.peakd.com/file/peakd-hive/gaottantacinque/23tvD6QisoLdoChsyyfmXPoWGYGDc8jWLrB2pY4nzhDXjpL8qvc88C1GAxkBSyddWg8TT.png';
